var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.9,6c3.2-2.7,7.9-2.4,10.7,0.6l-2-0.2l-0.1,1.2L19.7,8l0.4-4.1l-1.2-0.1l-0.2,2.1C15.4,2.3,9.9,1.9,6.1,5 C3.7,7,2.6,10.1,3,13.2L4.2,13C3.9,10.3,4.9,7.7,6.9,6z",
    fill: "#8F95AB"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21,10.8L19.8,11c0.3,2.7-0.7,5.3-2.7,7c-3.2,2.7-7.9,2.4-10.7-0.6l2,0.2l0.1-1.2L4.3,16l-0.4,4.1l1.2,0.1 l0.2-2.1c1.8,1.9,4.2,2.9,6.7,2.9c2.1,0,4.2-0.7,5.9-2.1C20.3,17,21.4,13.9,21,10.8z",
    fill: "#8F95AB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.ed3c67ce.svg";
export { ForwardRef as ReactComponent };